import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { Menu } from 'primeng/menu';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { ScholarshipService } from 'src/app/private/services/scholarship.service';
import { CreateScholarshipComponent } from "../../components/scholarship/create-scholarship/create-scholarship.component";
import { DeleteScholarshipComponent } from "../../components/scholarship/delete-scholarship/delete-scholarship.component";

@Component({
  selector: 'app-scholarship-configuration',
  imports: [ToolBarComponent, SharedModule, CreateScholarshipComponent, DeleteScholarshipComponent],
  templateUrl: './scholarship-configuration.component.html',
  styleUrl: './scholarship-configuration.component.scss'
})
export class ScholarshipConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddScholarship: boolean = false;
  editLeadFieldData: boolean = false;
  isEditScholarship: boolean = false;
  isDeleteScholarship: boolean = false;
  scholarshipData: any;

  items: any[] = [];

  columns: any[] = [
    { field: 'scholarship_code', header: 'Scholarship Code' },
    { field: 'name', header: 'Scholarship Name' },
    { field: 'type', header: 'Type' },
    { field: 'amount_type', header: 'Amount Type' },
    { field: 'amount_value', header: 'Amount Value' },
    { field: 'currency', header: 'Currency' },
    { field: 'max_beneficiaries', header: 'Max Beneficiaries' },
    { field: 'start_date', header: 'Start Date', type: 'date' },
    { field: 'end_date', header: 'End Date', type: 'date' },
    { field: 'renewable', header: 'Renewable', type: 'boolean' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];

  constructor(
    private api: ScholarshipService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }

  ScholarshipActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Scholarship',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditScholarship = true;
          }
        },
        {
          label: 'Delete Scholarship',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteScholarship = true;
          }
        }
      ]
    }
  ]

  setScholarshipEditData(rowData: any) {
    this.scholarshipData = rowData;
  }

  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"scholarship\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllScholarshipsWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load scholarships.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

  handleScholarship() {
    this.isAddScholarship = true;
  }

  handleCloseDialog() {
    this.isAddScholarship = false;
  }
}
